import { useNavigate } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/24/solid';

const BackButton = () => {
  const navigate = useNavigate();

  return (
    <button
      onClick={() => navigate(-1)}
      className="flex items-center text-gray-600 hover:text-gray-900 mb-6"
    >
      <ArrowLeftIcon className="h-5 w-5 mr-1" />
      Back
    </button>
  );
};

export default BackButton; 